enum TransferGroupType {
  NOT_COMPATIBLE = 'incompatible_items',
  TRANSFER = 'transfer_items',
}

export default TransferGroupType;
